var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "personal-deliver-page" }, [
    _c("article", { key: _vm.tempKey, staticClass: "panel-group" }, [
      _c(
        "section",
        { staticClass: "panel cargo-info panel-diff" },
        [_c("handling-wrapper", { ref: "handlingWrapper" })],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "panel deliver-info" },
        [
          _c("h3", { staticClass: "panel-header" }, [_vm._v("费用信息")]),
          _vm._v(" "),
          _c("cost-info-wrapper", { ref: "costInfo" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "panel deliver-note" },
        [
          _c("h3", { staticClass: "panel-header" }, [_vm._v("发货备注")]),
          _vm._v(" "),
          _c("transport-require", { ref: "transportRequire" })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "deliver-btn-wrap" },
      [
        _c(
          "el-button",
          {
            staticClass: "deliver-btn",
            attrs: { type: "primary", loading: _vm.deliverLoading },
            on: { click: _vm.deliverHandler }
          },
          [_vm._v("立即发货")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-eba3401a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-eba3401a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/deliver/index.vue
// module id = null
// module chunks = 